import { createContext, useContext, useState } from "react";

type DealerUIState = {
  hiddenPhone: boolean;
  setHiddenPhone: (value: boolean) => void;
  phoneNumber: string | undefined;
  setPhoneNumber: (value: string | undefined) => void;
  isLoadingTrackedPhoneNumber: boolean;
  setIsLoadingTrackedPhoneNumber: (value: boolean) => void;
  hasTrackedPhoneNumberFailed: boolean;
  setHasTrackedPhoneNumberFailed: (value: boolean) => void;
};

const DealerUIStateContext = createContext<DealerUIState | undefined>(undefined);

type Props = {
  children: React.ReactNode;
};

export function DealerUIStateProvider({ children }: Props) {
  const [hiddenPhone, setHiddenPhone] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState<string | undefined>();
  const [isLoadingTrackedPhoneNumber, setIsLoadingTrackedPhoneNumber] = useState(false);
  const [hasTrackedPhoneNumberFailed, setHasTrackedPhoneNumberFailed] = useState(false);

  return (
    <DealerUIStateContext
      value={{
        hiddenPhone,
        setHiddenPhone,
        phoneNumber,
        setPhoneNumber,
        isLoadingTrackedPhoneNumber,
        setIsLoadingTrackedPhoneNumber,
        hasTrackedPhoneNumberFailed,
        setHasTrackedPhoneNumberFailed,
      }}
    >
      {children}
    </DealerUIStateContext>
  );
}

export function useDealerUIState() {
  const context = useContext(DealerUIStateContext);
  if (typeof context === "undefined") {
    throw new Error("useDealerUIState must be used within a DealerUIStateProvider");
  }
  return context;
}
